import { AuthenticationController } from './auth/authentication-controller';
export default (function (_ref, inject) {
  var _app = _ref._app;
  var authenticationController = new AuthenticationController();

  // https://nuxtjs.org/docs/directory-structure/plugins/#inject-in-root--context
  inject('auth', authenticationController);
});